(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Register",
            {
                url: "/Register?state={currentToken}&authToken={token}&exists={userExists}",
                component: "register",
                resolve: {
                    onBefore: ["$stateParams", "userRegistrationApi", "$state", function ($stateParams, userRegistrationApi, $state) {
                        userRegistrationApi.getUserRegistrationByToken($stateParams.state).then(function (ur) {
                            if (Date.parse(ur.ExpirationDate) < Date.now()) {
                                $state.go("Invalid", { param: "expired" });
                            }
                            if (ur.Completed) {
                                $state.go("Login");
                            }
                        }, function () { $state.go("Invalid", { param: "invalid" }); });
                    }],
                    userRegistration: ["$stateParams", "userRegistrationApi", function ($stateParams, userRegistrationApi) {
                        return userRegistrationApi.getUserRegistrationByToken($stateParams.state);
                    }]
                }
            });
    }]);

    app.component("register",
        {
            templateUrl: "/App/Users/Register/template.html",
            controller: registerController,
            bindings: {
                userRegistration: "<"
            }

        });

    registerController.$inject = ["$stateParams", "complianceHubBaseApiUrl"];
    function registerController($stateParams, complianceHubBaseApiUrl) {
        var $ctrl = this;

        $ctrl.loading = true;
        redirectToFigAuth();

        function redirectToFigAuth() {
            var url = complianceHubBaseApiUrl + "/UserRegistrations/Complete/Fig?returnUrl=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host)
                + "&iComplyToken=" + window.encodeURIComponent($stateParams.state)
                + "&figAuthToken=" + window.encodeURIComponent($stateParams.authToken);
            window.location = url;
        }
    }

})(window.app, window.angular);